import { Component, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog, MatPaginator, MatTableDataSource } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription } from 'rxjs';
import { PRIMARY_COLOR } from 'src/app/app.component';
import { CustomerFilterLanguage } from 'src/app/core/class/customer-filter-language';
import { Message } from 'src/app/core/class/message';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { CommonService } from 'src/app/core/services/common.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ResponsiveService } from 'src/app/core/services/responsive.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { NotifyExportDataCustomerComponent } from 'src/app/shared/components/notify-export-data-customer-dialog/notify-export-data-customer-dialog.component';
import { NotifyExportDataCustomerSuccessComponent } from 'src/app/shared/components/notify-export-data-customer-success-dialog/notify-export-data-customer-success-dialog.component';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { UpdateGroupCustomerDialogComponent } from './update-group-customer-dialog/update-group-customer-dialog.component';
import {EnvService} from "../../../../../core/services/env.service";

@Component({
  selector: 'app-group-customer',
  templateUrl: './group-customer.component.html',
  styleUrls: ['./group-customer.component.scss']
})
export class GroupCustomerComponent implements OnInit {
  keyWord: string = ''

  // dataSource: DocumentDataSource;
  checkAll: boolean;
  dataSelected: Map<any, Document> = new Map<any, Document>();

  private _onDestroy = new Subject<void>();

  checkFocus = true;
  displayedColumns: string[] = [];

  columnDefinitions = [
    { def: "check", showMobile: true },
    { def: "id", showMobile: true },
    { def: "name", showMobile: true },
    { def: "description", showMobile: true },
    { def: "action", showMobile: true },
  ];
  isBasicSearchForm: boolean = false
  dataSource: MatTableDataSource<any>  = new MatTableDataSource();
  paginate: {
    currentPage: number,
    pageSize: number,
    totalRow: number,
    totalPage: number,
    totalPageArray: [],
    no: []
  };
  error = '';
  subscription: Subscription;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChildren('focusInput') focusInput;
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;

  permissions: any;
  isDefaultAdmin: any;
  private sme_hub_domain: string;

  constructor(
    public notificationService: NotificationService,
    public dialog: MatDialog,
    private customerService: CustomerService,
    public commonService: CommonService,
    private route: ActivatedRoute,
    private router: Router,
    private message: Message,
    private toastr: ToastrService,
    private storageService: StorageService,
    public customerFilter: CustomerFilterLanguage,
    private responsiveService: ResponsiveService,
    public deviceService: DeviceDetectorService,
    private env:EnvService

  ) {
    this.permissions = localStorage.getItem('permissions') ? JSON.parse(localStorage.getItem('permissions')) : [];
    this.isDefaultAdmin = this.commonService.checkDefaultAdmin();
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };
    this.sme_hub_domain = env.sme_portal_url

  }

  /**
   * Get initial data
   */
  ngOnInit() {
    this.notificationService.subscribeErrorService();
    this.onFilterCustomers();
    document.documentElement.style.setProperty('--colorIconBtn', '#00000042');
    window.scrollTo(0, 0);
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    // this.notificationService.unsubscribeErrorService();
    // this.subscribeMediaBreakPointService.unsubscribe();
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
    }
    // if (this.commonService.getIsLockedEnterprise()) {
    //   this.displayedColumns = this.columnDefinitions
    //     .filter(cd => (cd.def !== 'action' && cd.def !== 'status' && cd.def !== 'check'))
    //     .map(cd => cd.def);
    // }
  }

  /**
   * On click button delete customer
   */
  onClickIconDelete(id: number, name: string) {
    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.commonService.format(this.message.getMessage('messages.confirm_delete_group_customer'), name)
    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.customerService.deleteGroupCustomer({id: id}).subscribe(
          (rs) => {
            if(rs && rs.success){
            this.toastr.success(this.message.getMessage('messages.delete_success'));
            if (this.paginate.totalRow % this.paginate.pageSize === 1) {
              if (this.paginate.currentPage - 1 < 0) {
                this.paginate.currentPage = 0;
              } else {
                this.paginate.currentPage = this.paginate.currentPage - 1;
              }
            }
            this.onFilterCustomers(this.paginate.currentPage, this.paginate.pageSize);
            this.dataSelected.delete(id);
          } else{
              this.toastr.error(rs.message);
              if(rs.code == ErrorCode.GroupCustomerRemoved){
                this.onFilterCustomers(this.paginate.currentPage, this.paginate.pageSize);
              }
            }
          }
        );
      }
      this.focusInput.first.nativeElement.focus();
    });
  }

  /**
   * Filter customer
   */

  onFilterCustomers(page: number = 0, pageSize: number = 10) {
      this.customerService.filterCustomerGroups({
        page,
        pageSize,
        keyword: this.keyWord
      }).subscribe(
        rs => {
          this.bindData(rs);
        }
      );
  }


  public onSelectionChange(element) {
    if (element.checked) {
      this.dataSelected.set(element.id, element);
    } else {
      this.dataSelected.delete(element.id);
    }
    this.checkCheckAll();
    document.documentElement.style.setProperty('--colorIconBtn', this.commonService.getIsLockedEnterprise() || !this.dataSelected.size ? '#00000042' : PRIMARY_COLOR);
  }

  checkCheckAll() {
    if (this.dataSelected.size === 0) {
      this.checkAll = false;
      return;
    }
    for (let i = 0; i < this.dataSource.data.length; i++) {
      if (this.dataSelected.has(this.dataSource.data[i].id)) {
        this.dataSource.data[i].checked = true;
      }
    }

    for (let i = 0; i < this.dataSource.data.length; i++) {
      if (!this.dataSelected.has(this.dataSource.data[i].id)) {
        this.checkAll = false;
        break;
      }
      if (i === this.dataSource.data.length - 1) {
        this.checkAll = true;
      }
    }
  }

  public checkAllDocument() {
    this.dataSource.data.forEach(data => {
      data.checked = this.checkAll;
      this.dataSelected.set(data.id, data);
      if(!this.checkAll) {
        this.dataSelected.delete(data.id);
      }
    });
    document.documentElement.style.setProperty('--colorIconBtn', this.commonService.getIsLockedEnterprise() || !this.dataSelected.size ? '#00000042' : PRIMARY_COLOR);
  }


  /**
   * Bind data from api
   */
  private bindData(rs: any) {
    if (rs == null || rs.data == null || rs.data.content == null) {
      return 0;
    }
    this.paginate = {
      currentPage: rs.data.pageable.page,
      pageSize: rs.data.pageable.size,
      totalRow: rs.data.total,
      totalPage: Math.ceil(rs.data.total / rs.data.pageable.size),
      totalPageArray: this.commonService.counter(Math.ceil(rs.data.total / rs.data.pageable.size), 1),
      no: this.commonService.counter(rs.data.pageable.size, rs.data.pageable.page * rs.data.pageable.size + 1)
    };
    this.dataSource.data = rs.data.content;
    /* đối chiếu list mới trả về và danh sách object đã check */
    // nếu mà map object đã check tồn tại ở trong list hiện => chuyển trạng thái thành checked = true
    this.checkCheckAll();
  }

  /**
   * Bind old search data to variable oldData to avoid error
   */
  onClickBtnFilter() {
    this.onFilterCustomers(this.paginate.currentPage, this.paginate.pageSize);
  }

  updateGroup(id){
    this.customerService.detailGroupCustomer({id: id}).subscribe(rs => {
      if(rs && rs.success){
        const dialog = this.dialog.open(UpdateGroupCustomerDialogComponent, {
          data: rs.data,
          width: "40%"
        })
        dialog.afterClosed().subscribe(rs => {
          if(rs){
            if(rs == ErrorCode.GroupCustomerRemoved){
              if (this.paginate.totalRow % this.paginate.pageSize === 1) {
                if (this.paginate.currentPage - 1 < 0) {
                  this.paginate.currentPage = 0;
                } else {
                  this.paginate.currentPage = this.paginate.currentPage - 1;
                }
              }
            }
            this.onFilterCustomers(this.paginate.currentPage, this.paginate.pageSize);
          }
        })
      }else{
        this.toastr.error(rs.message);
        if(rs.code == ErrorCode.GroupCustomerRemoved){
          if (this.paginate.totalRow % this.paginate.pageSize === 1) {
            if (this.paginate.currentPage - 1 < 0) {
              this.paginate.currentPage = 0;
            } else {
              this.paginate.currentPage = this.paginate.currentPage - 1;
            }
          }
          this.onFilterCustomers(this.paginate.currentPage, this.paginate.pageSize);
        }
      }
    })
  }

  manageCustomerGroup(id){
    this.router.navigate([`/home-enterprise/manage-group-customers/${id}`])
  }

  /**
   *
   */
  onClickBtnAdd() {
    if(this.isSMEHubAccount()){
      window.open(`${this.sme_hub_domain}/admin/customer-group-management`,'_blank');
      return;
    }
    // changes the route without moving from the current view or
    // triggering a navigation event,
    this.router.navigate(['/home-enterprise/create-group-customers'], {
    });
  }

  isSMEHubAccount(){
    return localStorage.getItem('isFromSSO') =='true';
  }

  exportData(isExportFullCustomerInformation: boolean) {
    const dialogRef = this.dialog.open(NotifyExportDataCustomerComponent, {
      data: {
        typeDialog: isExportFullCustomerInformation ? 'export_group_customer_full' : 'export_group_customer_compact',
        groupCustomers: Array.from(this.dataSelected.values()).map((data: any) => data.name)
      },
      width: '40%'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if(result !== false) {
        let data = {
          requestExportCustomerGroup: {
            customerGroupIds: Array.from(this.dataSelected.keys()),
            customerIds: null,
            isExportByGroup: true,
            isExportFullCustomerInformation: isExportFullCustomerInformation
          }
        }
        this.customerService.createExportExcelHistory(data).subscribe({
          next: (rs) => {
            if(rs && (rs.code == ErrorCode.ExportGroupCustomerNotFound || rs.code == ErrorCode.ExportGroupCustomerNotPermission || rs.code == ErrorCode.ExportCustomerNotPermission || rs.code == ErrorCode.ExportCustomerNotFound)) {
              this.toastr.error(rs.message);
              return;
            }
            if (rs == null || rs.data == null) {
              return 0;
            }
            if(result == 'export') {
              const dialogRef = this.dialog.open(NotifyExportDataCustomerSuccessComponent, {
                width: '550px'
              });
              return;
            }
            if(result == 'export_and_view') {
              this.router.navigate(['/home-enterprise/export-data-customer']);
              return;
            }
          }
        })
      }
    });
  }

  checkDisplayBtnAssignGroup() {
    if(this.isDefaultAdmin) {
      return true;
    }
    if(this.permissions.includes(405)) {
      return true;
    }
    if(this.permissions.includes(4)) {
      return true;
    }

    if(this.isSMEHubAccount()){
      return false;
    }

    return false;
  }

}
